import cc from 'classcat';
import React, { useEffect, useRef } from 'react';
import { useEscapeListener } from '../../../hooks/documentEvents/useEscapeListener';

interface IModal {
    isVisible: boolean;
    children: React.ReactNode;
    closeModal: (e?: any) => void;
}

export const Modal = ({ isVisible, children, closeModal }: IModal) => {
    const downTargetClass = useRef<string>();

    useEffect(() => {
        if (!isVisible) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') closeModal();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isVisible, closeModal]);

    const checkMouseEvents = (upTargetClass: string) => {
        if (downTargetClass.current === 'modal' && upTargetClass === 'modal') closeModal();
    };

    return (
        <div
            className={cc(['modal', { 'modal--hidden': !isVisible }])}
            onMouseDown={e => (downTargetClass.current = (e.target as Element).className)}
            onMouseUp={e => checkMouseEvents((e.target as Element).className)}
        >
            {isVisible && children}
        </div>
    );
};
